// extracted by mini-css-extract-plugin
export default {"error_style":"errorMessage_error_style__dUz4b"};